import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/anime";

const navLinks = [
  { to: "/", label: "首页", end: true },
  { to: "/category/hotblood", label: "分类" },
  { to: "/search", label: "搜索" },
  { to: "/about", label: "关于" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMobileOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[68px] gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0 group">
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-tv-2-fill text-xl md:text-2xl"></i>
            </span>
            <span className="font-heading font-extrabold text-base md:text-lg text-foreground-950 whitespace-nowrap">
              动漫免费在观看
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <div
                key={link.to}
                className="relative"
                onMouseEnter={() => link.label === "分类" && setCategoryOpen(true)}
                onMouseLeave={() => link.label === "分类" && setCategoryOpen(false)}
              >
                <NavLink
                  to={link.to}
                  end={link.end}
                  className={({ isActive }) =>
                    `flex items-center gap-1 px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                      isActive
                        ? "text-primary-600 bg-primary-50"
                        : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                    }`
                  }
                >
                  {link.label}
                  {link.label === "分类" && (
                    <i className={`ri-arrow-down-s-line text-base transition-transform ${categoryOpen ? "rotate-180" : ""}`}></i>
                  )}
                </NavLink>

                {link.label === "分类" && categoryOpen && (
                  <div className="absolute left-0 top-full pt-2 w-[460px] animate-fade-in">
                    <div className="bg-background-50 border border-background-200 rounded-xl p-3 grid grid-cols-2 gap-1">
                      <Link
                        to="/category/all"
                        className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors"
                      >
                        <span className="w-6 h-6 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                          <i className="ri-apps-2-line text-base"></i>
                        </span>
                        全部动漫
                      </Link>
                      {categories.map((cat) => (
                        <Link
                          key={cat.id}
                          to={`/category/${cat.id}`}
                          className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors"
                        >
                          <span className="w-6 h-6 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                            <i className={`${cat.icon} text-base`}></i>
                          </span>
                          {cat.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <form
              onSubmit={handleSearch}
              className="hidden lg:flex items-center gap-2 bg-background-100 border border-background-200 rounded-full pl-3 pr-1 py-1 focus-within:border-primary-400 transition-colors"
            >
              <i className="ri-search-line text-foreground-500 text-sm"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索动漫、角色、类型"
                className="bg-transparent outline-none text-sm w-44 xl:w-56 text-foreground-900 placeholder:text-foreground-400"
              />
              <button
                type="submit"
                className="px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                搜索
              </button>
            </form>

            <Link
              to="/search"
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-700"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </Link>

            <button
              type="button"
              onClick={() => setMobileOpen((v) => !v)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md bg-background-100 text-foreground-800 cursor-pointer"
              aria-label="菜单"
            >
              <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <div className="px-4 py-3">
            <form onSubmit={handleSearch} className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-full pl-3 pr-1 py-1 mb-3">
              <i className="ri-search-line text-foreground-500 text-sm"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索动漫"
                className="bg-transparent outline-none text-sm flex-1 text-foreground-900 placeholder:text-foreground-400"
              />
              <button type="submit" className="px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap cursor-pointer">
                搜索
              </button>
            </form>

            <div className="flex flex-col">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.end}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `px-2 py-3 rounded-lg text-sm font-medium ${
                      isActive ? "text-primary-600 bg-primary-50" : "text-foreground-700"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
            </div>

            <div className="mt-3 pt-3 border-t border-background-200">
              <p className="text-xs text-foreground-500 mb-2">动漫分类</p>
              <div className="flex flex-wrap gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.id}`}
                    onClick={() => setMobileOpen(false)}
                    className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}